import { createContext, useContext, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

// Holds the Campaign dashboard's fetched data + view state ABOVE the router so
// it survives navigating away to another dashboard and back (routes unmount).
const CampaignDataContext = createContext(null);

export function CampaignDataProvider({ children }) {
  const { currentUser } = useAuth();
  const [appData, setAppData]       = useState(null);
  // An empty selection means "All"; otherwise include every selected KAM.
  // Defaults to the logged-in KAM's own first name (still fully changeable —
  // "access is still complete", this only sets the starting selection).
  const [kamFilter, setKamFilter]   = useState(() => currentUser?.kamFirstName ? [currentUser.kamFirstName] : []);
  const [activeTab, setActiveTab]   = useState('summary');

  return (
    <CampaignDataContext.Provider
      value={{ appData, setAppData, kamFilter, setKamFilter, activeTab, setActiveTab }}>
      {children}
    </CampaignDataContext.Provider>
  );
}

export function useCampaignData() {
  return useContext(CampaignDataContext);
}
